import { Link } from 'react-router-dom';

import Box from '@mui/joy/Box';

import ListItem from '@mui/joy/ListItem';
import ListItemButton, { ListItemButtonProps } from '@mui/joy/ListItemButton';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Chip from '@mui/joy/Chip';
import Tooltip from '@mui/joy/Tooltip';
import { FHRequestType } from 'stores/fhrequest_store';
import useUserIdentity from 'hooks/useUserIdentity';
import IdentityAvatar from 'components/IdentityAvatar';
import RequestPrice from 'components/RequestPrice';
import { DateOrTime } from 'components/Date';
import getIcon from 'utils/getIcon';

import { REQUEST_STATUS } from 'utils/misc';

import { Divider } from '@mui/joy';
import useClock from 'hooks/useClock';
import ClockTotalChip from './ClockTotalChip';

type MessageListItemProps = ListItemButtonProps & {
    request: FHRequestType;
};

export function ClockedInChip() {
    const ClockIcon = getIcon('DayOnesClockIn');
    return (<Tooltip arrow
        title="You are currently clocked in here.">
        <Chip color="primary" variant="outlined" size="sm" ><ClockIcon  sx={{ mt: 0.5, mb: 0}} fontSize={"12"} /></Chip>
    </Tooltip>
    );
}

export default function RequestListItem({
    request,
}: MessageListItemProps) {

    const { currentIdentity } = useUserIdentity();
    const { currentClock } = useClock();
    const clockedIn = currentClock?.associated_uuid &&
        (currentClock?.associated_uuid == request.uuid);

    return (
        <>
            <Link to={`/request/${request.key}`}>
                <ListItemButton
                    variant={clockedIn ? 'soft' : 'plain'}
                    color={clockedIn ? 'primary' : 'neutral'}
                    sx={{
                        padding: 0,
                        borderRadius: 'lg',
                        transition: 'background-color 0.8s',
                    }}
                >
                    <ListItem
                        sx={{
                            px: 0,
                            margin: 0,
                            width: '100%'
                        }}
                    >
                        <Stack
                            sx={{ width: '100%' }}
                            spacing={1}
                            margin={1}
                        >
                            <Stack direction="row"
                            >
                                <Stack spacing={1}>
                                    <Typography
                                        level="title-lg"
                                    >
                                        {request.title || 'Untitled Request'}
                                    </Typography>
                                </Stack>

                                <Box flexGrow={1} />

                                <RequestPrice request={request} />

                            </Stack>


                                <Stack
                                    alignItems="center"
                                    direction="row"
                                    spacing={1}

                                    sx={{ '--Avatar-size': '18px' }}
                                >
                                <Stack
                                    alignItems="center"
                                    direction="row"
                                    spacing={1}

                                    divider={<Divider orientation="vertical" />}
                                >

                                    {(request.identity != currentIdentity.key) && request.identity &&
                                        <Tooltip arrow title="Client">
                                    <Typography level="body-xs">
                                        <IdentityAvatar
                                            interactive={false}
                                            size="inline"
                                            identityKey={request.identity} />
                                    </Typography>
                                        </Tooltip>
                                    }

                                {request.claimed_identity &&
                                    <Stack spacing={1}
                                        sx={{ display: { xs: 'none', md: 'flex' } }} direction="row" alignItems="center">
                                        <Tooltip arrow title="Assistant">
                                        <Typography level="body-xs">
                                            <IdentityAvatar
                                                interactive={false}
                                                size="inline"
                                                identityKey={request.claimed_identity} />
                                        </Typography>
                                        </Tooltip>
                                    </Stack>
                                }
                                {!request.claimed_identity && request.claimed_by &&
                                    <Stack sx={{ display: { xs: 'none', md: 'flex' } }} >
                                        <Typography level="body-xs">
                                            Claimed
                                        </Typography>
                                    </Stack>
                                }
                                </Stack>

                                <Box flexGrow={1} />
                                <Stack
                                    alignItems="center"
                                    direction="row"
                                    spacing={1}
                                    divider={<Divider orientation="vertical" />}
                                >

                                    {/*

                                    {request.source > 20 &&
                                        <Tooltip arrow
                                            title="Created via Day Ones platform.">
                                            <Chip
                                                startDecorator={<SunriseIcon color="success" />}
                                                color="success"
                                                size="sm">
                                                {REQUEST_SOURCE.NAME(request.source)}
                                            </Chip>
                                        </Tooltip>
                                    }

                                    {request.source <= 20 &&
                                        <Tooltip arrow
                                            title="Created via the original Fancy Hands site.">
                                            <Chip size="sm">
                                                {REQUEST_SOURCE.NAME(request.source)}
                                            </Chip>
                                        </Tooltip>
                                    }
                                      */}

                                      {clockedIn && <ClockedInChip />}


                                      { request.clock_total_seconds > 0 &&
                                        <ClockTotalChip
                                            total_seconds={request.clock_total_seconds}
                                        />
                                      }
                                    <Chip size="sm" variant="outlined" color={REQUEST_STATUS.COLOR(request.status)}>
                                        {REQUEST_STATUS.NAME(request.status)}
                                    </Chip>

                                    <Typography level="body-xs">
                                        <DateOrTime ts={request.date_created} />
                                    </Typography>

                                </Stack>
                            </Stack>

                        </Stack>
                    </ListItem>
                </ListItemButton>
            </Link>

        </>
    );
}
